<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent @change="onYearSelected" />
      </el-col>
      <el-col :span="3">
        <MonthsComponent @change="OnMonthSelected" />
      </el-col>
      <el-col :span="3">
        <PaymentsAndInvoicesSelector @PaymentSelected="OnPaymentSelected" />
      </el-col>
      <el-col :span="3"></el-col>
    </el-row>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import PaymentsAndInvoicesSelector from "@/components/fiances/reports/filters/PaymentsAndInvoicesSelector";

export default {
  name: "ClientRabbeyPaymentAndInvoicingReportFilters",
  components: {
    YearsComponent,
    MonthsComponent,
    PaymentsAndInvoicesSelector
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    onYearSelected(year) {
      this.$emit("onYearSelected", year);
    },
    OnMonthSelected(month) {
      this.$emit("onMonthSelected", month);
    },
    OnPaymentSelected(value) {
      this.$emit("PaymentSelected", value);
    }
  }
};
</script>

<style scoped></style>
